import { User } from 'models/user.model';

export const TASK_STATUS = {
  NOT_SAVED: 'Not saved',
  DRAFT: 'Draft',
  APPROVED: 'Approved',
  PENDING_APPROVAL: 'Pending approval',
} as const;

export const WORK_MODEL = {
  WORK_FROM_HOME: 'Home',
  WORK_FROM_OFFICE: 'Office',
} as const;

export const VALIDATION_TYPE = {
  NULL: 'null',
  ACCEPT_BUTTON: 'Accept button',
  ANY_NUMBER: 'Any number',
  ANY_TEXT: 'Any text',
  CONTAINS: 'Contains',
} as const;

export type TaskStatus = keyof typeof TASK_STATUS;
export type WorkModel = keyof typeof WORK_MODEL;
export type ValidationType = keyof typeof VALIDATION_TYPE;
export type FormMode = 'CREATE' | 'VIEW' | 'EDIT';

export interface Task {
  readonly id: string;
  title: string;
  description: string;
  status: TaskStatus;
  workModels: WorkModel[];
  validator: ValidationType;
  answer: string;
  errorMessage: string;
  readonly author: User;
  readonly createdAt: string;
  readonly updatedAt: string;
}

export type DraftTask = Omit<Task, 'id' | 'author' | 'createdAt' | 'updatedAt'>;
